import { render } from "./CostDetail.vue?vue&type=template&id=c04c0608"
import script from "./CostDetail.vue?vue&type=script&lang=js"
export * from "./CostDetail.vue?vue&type=script&lang=js"

import "./CostDetail.vue?vue&type=style&index=0&id=c04c0608&lang=css"
script.render = render

export default script